import { call, put, select } from 'redux-saga/effects'
// TODO: Re-enable this for web platforms
// import { push } from 'connected-react-router'
// import { ROUTES } from '../constants/app'

import {
  clearSessionData,
  getSessionToken,
  getIframeSessionToken,
  sendLogoutSignal,
  setSessionToken,
  setIframeSessionToken,
} from '../api/account'
import req from '../api/request'
import actions from '../actions/auth'
import { generateSagas } from './utils'

export const api = {
  login: async (body) =>
    await req('/auth/login', { method: 'POST', body, requiresAuth: false }),
  register: async (body) =>
    await req('/users', { method: 'POST', body, requiresAuth: false }),
  refresh: async (useIframeToken) =>
    await req('/auth/refresh', {
      method: 'POST',
      useIframeToken,
      timeout: 10000,
    }),
  verify: async (body) =>
    await req('/users/verify', { method: 'POST', body, requiresAuth: false }),
  resend: async (body) =>
    await req('/users/resend', { method: 'POST', body, requiresAuth: false }),

  changePassword: async (body) =>
    await req('/auth/password', { method: 'PUT', body }),
  forgotPassword: async (body) =>
    await req('/auth/password/reset', {
      method: 'POST',
      body,
      requiresAuth: false,
    }),
  resetPassword: async (body) =>
    await req('/auth/password', { method: 'POST', body, requiresAuth: false }),

  impersonate: async (body) =>
    await req('/auth/impersonate', { method: 'POST', body }),
}

function* setCredentials(response) {
  const inFrame = yield select((state) => state.auth.inFrame)

  // store token in local storage
  inFrame
    ? yield setIframeSessionToken(response.access_token)
    : yield setSessionToken(response.access_token)
  yield put(actions.login.success(response.user))
  return response.user
}

const auth = [
  [
    actions.login,
    function* ({ form }) {
      const body = JSON.stringify({ ...form })

      // log you out, basically
      yield call(clearSessionData)

      const response = yield call(api.login, body)
      return yield call(setCredentials, response)
    },
  ],

  [
    actions.impersonate,
    function* ({ form }) {
      const body = JSON.stringify(form)
      const response = yield call(api.impersonate, body)

      // log you out, basically
      yield call(clearSessionData)

      return yield call(setCredentials, response)
    },
  ],

  [
    actions.register,
    function* ({ form }) {
      const body = JSON.stringify({ ...form })
      return yield call(api.register, body)
    },
  ],

  [
    actions.logout,
    function* (payload) {
      yield call(clearSessionData)
      yield call(sendLogoutSignal)
      yield put(actions.logout.success())

      // Adding a history entry to the homepage will prevent user from being redirected
      // to a previously viewed organization tab upon re-login (which they may or
      // may not have permission to view!)
      //
      // However, this saga is called via auto-logout due to a failed login or a newly
      // created account - and we don't want to do any navigation in those scenarios.
      // if (payload && payload.goToHome) yield put(push(ROUTES.HOME))
    },
  ],

  [
    actions.refresh,
    function* () {
      const inFrame = yield select((state) => state.auth.inFrame)
      const token = inFrame
        ? yield getIframeSessionToken()
        : yield getSessionToken()

      if (token === null) throw new Error('No session token to refresh.')

      const response = yield call(api.refresh, inFrame)
      return yield call(setCredentials, response)
    },
  ],

  [
    actions.verify,
    function* ({ token }) {
      const body = JSON.stringify({ token })
      const response = yield call(api.verify, body)

      return yield call(setCredentials, response)
    },
  ],

  [
    actions.resend,
    function* ({ email }) {
      const body = JSON.stringify({ email })
      return yield call(api.resend, body)
    },
  ],

  [
    actions.forgot,
    function* ({ email }) {
      const body = JSON.stringify({ ...email })
      return yield call(api.forgotPassword, body)
    },
  ],

  [
    actions.reset,
    function* ({ password, token }) {
      const body = JSON.stringify({ password, token })
      const response = yield call(api.resetPassword, body)

      return yield call(setCredentials, response)
    },
  ],

  [
    actions.change,
    function* ({ form }) {
      const body = JSON.stringify({
        password_old: form.password_old,
        password: form.password,
      })
      return yield call(api.changePassword, body)
    },
  ],
]

export default generateSagas([...auth])
